.eyebrow { display: flex; align-items: center; gap: 10px; margin: 0; font-family: var(--font-mono); font-size: 11px; letter-spacing: 1.6px; color: var(--text-secondary); text-transform: uppercase; }
.tick { width: 30px; height: 2px; background: var(--hot); flex: none; }
@media (max-width: 639px) {
  .eyebrow { font-size: 10px; letter-spacing: 1.4px; }
  .tick { width: 24px; }
}
